import { MediaParametersRequestInputCategory } from '@/api/generated/models'

export const formats = [
  {
    key: 1,
    label: 'Standard',
    value: 'standard',
  },
  {
    key: 1,
    label: 'Semi-standard',
    value: 'semi-standard',
  },
  {
    key: 1,
    label: 'Non-standard',
    value: 'non-standard',
  },
  {
    key: 1,
    label: 'Unformatted',
    value: 'unformatted',
  },
]

export const intervalOptions = [
  {
    key: 1,
    label: 'Monthly',
    value: 'monthly',
  },
  {
    key: 2,
    label: 'Daily',
    value: 'daily',
  },
  {
    key: 3,
    label: 'Weekly',
    value: 'weekly',
  },
]

export const unitOptions = [
  {
    key: 1,
    label: 'Currency',
    value: 'currency',
  },
  {
    key: 2,
    label: 'Volume',
    value: 'volume',
  },
  {
    key: 3,
    label: 'Percent',
    value: 'percent',
  },
  {
    key: 4,
    label: 'Temperature',
    value: 'temperature',
  },
  {
    key: 5,
    label: 'Mean',
    value: 'mean',
  },
  {
    key: 6,
    label: 'Onehot',
    value: 'onehot',
  },
  {
    key: 7,
    label: 'Value',
    value: 'value',
  },
]

export const roles_list = [
  {
    key: 1,
    label: 'User',
    value: 'user',
  },
  {
    key: 2,
    label: 'Manager',
    value: 'manager',
  },
]

export const aggregationMethodOptions = [
  {
    key: 1,
    value: 'mean',
    label: 'Mean',
  },
  {
    key: 2,
    value: 'median',
    label: 'Median',
  },
  {
    key: 3,
    value: 'sum',
    label: 'Sum',
  },
  {
    key: 4,
    value: 'max',
    label: 'Max',
  },
  {
    key: 5,
    value: 'min',
    label: 'Min',
  },
]

export const influenceOptions = [
  {
    key: 1,
    value: '',
    label: 'Not set',
  },
  {
    key: 2,
    value: 'high',
    label: 'High',
  },
  {
    key: 3,
    value: 'medium',
    label: 'Medium',
  },
  {
    key: 4,
    value: 'low',
    label: 'Low',
  },
  {
    key: 5,
    value: 'none',
    label: 'None',
  },
]

export const investmentOptions = [
  {
    key: 1,
    value: '',
    label: 'Not set',
  },
  {
    key: 2,
    value: 'high',
    label: 'High',
  },
  {
    key: 3,
    value: 'medium',
    label: 'Medium',
  },
  {
    key: 4,
    value: 'low',
    label: 'Low',
  },
  {
    key: 5,
    value: 'none',
    label: 'None',
  },
]

// General dataset categories
export const categoryOptions = [
  {
    key: 1,
    value: '',
    label: 'Select',
  },
  {
    key: 2,
    value: 'revenue',
    label: 'Revenue',
  },
  {
    key: 3,
    value: 'price',
    label: 'Price',
  },
  {
    key: 4,
    value: 'cost',
    label: 'Cost',
  },
  {
    key: 5,
    value: 'macro',
    label: 'Macro',
  },
  {
    key: 6,
    value: 'weather',
    label: 'Weather',
  },
  {
    key: 7,
    value: 'sentiment',
    label: 'Sentiment',
  },
  {
    key: 8,
    value: 'traffic',
    label: 'Traffic',
  },
  {
    key: 9,
    value: 'finance',
    label: 'Finance',
  },
  {
    key: 10,
    value: 'event',
    label: 'Event',
  },
  {
    key: 11,
    value: 'distribution',
    label: 'Distribution',
  },
  {
    key: 12,
    value: 'promotion',
    label: 'Promotion',
  },
  {
    key: 13,
    value: 'reach',
    label: 'Exposure',
  },
  {
    key: 14,
    value: 'spend',
    label: 'Spend',
  },
  {
    key: 15,
    value: 'revenue_per_kpi',
    label: 'Revenue per KPI',
  },
]

// Media input categories (for media channels only)
export const mediaInputCategoryOptions = [
  {
    key: 1,
    value: '',
    label: 'Select',
  },
  {
    key: 2,
    value: 'spend',
    label: 'Spend',
  },
  {
    key: 3,
    value: 'reach',
    label: 'Reach',
  },
  {
    key: 4,
    value: 'frequency',
    label: 'Frequency',
  },
  {
    key: 5,
    value: 'impressions',
    label: 'Impressions',
  },
]

type MediaInputCategory = keyof typeof MediaParametersRequestInputCategory

type CategoryOption = {
  key: number
  value: MediaInputCategory
  label: string
}

export const inputCategoryOptions: CategoryOption[] = [
  {
    key: 2,
    value: 'spend',
    label: 'Spend',
  },
  {
    key: 3,
    value: 'reach',
    label: 'Reach',
  },
  {
    key: 4,
    value: 'frequency',
    label: 'Frequency',
  },
  {
    key: 5,
    value: 'impressions',
    label: 'Impressions',
  },
]

export const roiAssumptionOptions = [
  {
    key: 1,
    value: '',
    label: '-',
  },
  {
    key: 2,
    value: 'standard',
    label: 'Medium',
  },
  {
    key: 3,
    value: 'conservative',
    label: 'Low',
  },
  {
    key: 4,
    value: 'aggressive',
    label: 'Full',
  },
]

export const baselineForNonMediaOptions = [
  {
    key: 1,
    value: 'min',
    label: 'Minimum',
  },
  {
    key: 2,
    value: 'max',
    label: 'Maximum',
  },
  {
    key: 3,
    value: 'mean',
    label: 'Mean value',
  },
]
